import {
    Drawer,
    Portal,
    CloseButton,
    Box,
} from "@chakra-ui/react";

const AppDrawer = ({
    open,
    onClose,
    title,
    children,
    width = "420px",
}) => {
    return (
        <Drawer.Root
            open={open}
            onOpenChange={(e) => {
                if (!e.open) onClose();
            }}
            placement="end"
      
         
        >
            <Portal>
                <Drawer.Backdrop
                    bg="rgba(15,23,42,0.12)"
                    backdropFilter="blur(2px)"
                />

                <Drawer.Positioner>
                    <Drawer.Content
                        maxW={width}
                        borderLeft="4px solid"
                        borderColor="white"
                        bg="white"
                    >
                        <Drawer.Header
                            borderBottom="1px solid"
                            borderColor="gray.200"
                            minH="64px"
                        >
                            <Drawer.Title>
                                {title}
                            </Drawer.Title>

                            <Drawer.CloseTrigger
                                asChild
                            >
                                <CloseButton
                                    size="sm"
                                />
                            </Drawer.CloseTrigger>
                        </Drawer.Header>

                        <Drawer.Body p={0}>
                            <Box
                                p={6}
                                pb={15}
                                h="100%"
                                overflowY="auto"
                            >
                                {children}
                            </Box>
                        </Drawer.Body>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Portal>
        </Drawer.Root>
    );
};

export default AppDrawer;